/* v94.7 homepage motion (15 Oct). Loaded sitewide from sections/pw-ns-global.liquid.
   1. Shortlist marquee ([data-pw-marquee], hero): scrolls right to left at every width (requestAnimationFrame),
      about one card every 3.5s. Pauses on mouse hover, keyboard focus and touch, resumes 1.8s after a touch ends;
      a sideways swipe moves it. Stops off screen or in a hidden tab. Reduced motion: a much slower drift.
   2. Pick rings ([data-pw-ring]): the ring fills as it scrolls into view. Polish round 2: once full the card gets
      .is-full and the CSS loops a slow dashed ring and a light sweep (assets/pw-947.css). Reduced motion: full and still.
   3. Runners-up: each card's image cycle starts a little later than the one before, so they do not flip together
      (data-pw-delay, read by assets/pw-cardvid.js). */
(function () {
  if (window.__pw947) return; window.__pw947 = 1;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ready = function (f) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', f); else f(); };

  function marquee(win) {
    if (win.__pwm) return;
    var track = win.querySelector('.ns-shelf__track');
    if (!track) return;
    var lists = track.querySelectorAll('.ns-shelf__list');
    if (lists.length < 2 || !lists[0].children.length) return;
    win.__pwm = 1; win.classList.add('pw-mqw');
    if (RM) win.classList.add('pw-mqw--rm');
    /* Shortlist motion fix (15 Oct): one horizontal right-to-left loop at every width (copy 2 makes it seamless).
       Speed is one card every ~3.5s (reduced motion: one card every ~16s, a slow drift instead of stopping).
       Pauses only for a real mouse hover, keyboard focus or a finger on it, then resumes. iOS Safari fires
       emulated mouseenter and focus on a tap and never the matching leave, which froze the old version. */
    var n = lists[0].children.length, SECS = RM ? 16000 : 3500;
    var off = 0, last = 0, raf = 0, vis = true, hov = false, foc = false, hold = 0, drag = null, moved = 0;
    function per() { return lists[1].offsetLeft - lists[0].offsetLeft; }
    function paint() {
      var p = per();
      if (p > 0) off = ((off % p) + p) % p;
      track.style.transform = 'translate3d(' + (-off) + 'px,0,0)';
    }
    function tick(t) {
      raf = 0;
      var dt = last ? Math.min(1000, t - last) : 16; last = t;
      var p = per();
      if (p > 0 && !hov && !foc && !drag && Date.now() > hold) off += dt * (p / n) / SECS;
      paint();
      if (vis && !document.hidden) raf = requestAnimationFrame(tick); else last = 0;
    }
    function go() { if (!raf && vis && !document.hidden) { last = 0; raf = requestAnimationFrame(tick); } }
    win.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hov = true; });
    win.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hov = false; });
    win.addEventListener('focusin', function () { try { foc = win.matches(':focus-visible') || !!win.querySelector(':focus-visible'); } catch (x) { foc = false; } });
    win.addEventListener('focusout', function () { foc = false; });
    win.addEventListener('touchstart', function (e) { var t = e.touches[0]; hov = false; drag = { x: t.clientX, y: t.clientY, o: off, h: null }; }, { passive: true });
    win.addEventListener('touchmove', function (e) {
      if (!drag) return;
      var t = e.touches[0], dx = t.clientX - drag.x, dy = t.clientY - drag.y;
      if (drag.h === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) drag.h = Math.abs(dx) > Math.abs(dy);
      if (drag.h) { off = drag.o - dx; paint(); }
    }, { passive: true });
    function end() { if (drag && drag.h) moved = Date.now(); drag = null; hold = Date.now() + 1800; }
    win.addEventListener('touchend', end);
    win.addEventListener('touchcancel', end);
    win.addEventListener('click', function (e) { if (moved && Date.now() - moved < 400) { e.preventDefault(); e.stopPropagation(); } }, true);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; go(); }).observe(win);
    document.addEventListener('visibilitychange', go);
    window.addEventListener('pageshow', go);
    /* Second image cycling: pw-cardvid.js only cycles on touch phones without reduced motion, so the shortlist
       cycles here on desktop and under reduced motion as well (every 3s, staggered, only while on screen). */
    var CYC = RM || (window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches);
    if (CYC) {
      var imgs = [].filter.call(win.querySelectorAll('.pwb-card__img'), function (w) {
        return [].filter.call(w.children, function (c) { return c.tagName === 'IMG'; }).length > 1;
      });
      imgs.forEach(function (w, i) { setTimeout(function () { setInterval(function () { if (vis && !document.hidden) w.classList.toggle('pw-alt-on'); }, 3000); }, 600 + (i % n) * 450); });
    }
    go();
  }

  function rings(root) {
    var els = [].slice.call((root || document).querySelectorAll('[data-pw-ring]')).filter(function (e) { return !e.__pwr; });
    if (!els.length) return;
    els.forEach(function (e) { e.__pwr = 1; });
    function upd() {
      var vh = window.innerHeight || 800;
      els.forEach(function (el) {
        var fg = el.querySelector('.ns-ring__fg');
        var p = 1;
        if (!RM) {
          var r = el.getBoundingClientRect();
          p = r.bottom < 0 ? 1 : Math.max(0, Math.min(1, (vh - r.top) / (vh * 0.65)));
        }
        if (fg) fg.style.strokeDashoffset = String(100 - p * 100);
        el.style.setProperty('--p', p.toFixed(3));
        if (p >= 0.999) el.classList.add('is-full');
        else if (p < 0.5) el.classList.remove('is-full');
      });
    }
    upd();
    if (RM) return;
    var q = 0;
    var on = function () { if (q) return; q = requestAnimationFrame(function () { q = 0; upd(); }); };
    window.addEventListener('scroll', on, { passive: true });
    window.addEventListener('resize', on);
  }

  function stagger(root) {
    (root || document).querySelectorAll('.ns-picks__three').forEach(function (ul) {
      ul.querySelectorAll('.pwb-card__img').forEach(function (w, i) {
        if (!w.hasAttribute('data-pw-delay')) w.setAttribute('data-pw-delay', String(i * 800));
      });
    });
  }

  function init(root) {
    stagger(root);
    (root || document).querySelectorAll('[data-pw-marquee]').forEach(marquee);
    rings(root);
  }
  ready(function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
